module.exports = __webpack_public_path__ + "tk.svg?4487439056ff02dbe8e388c1139f5f2d";